import React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import clsx from 'clsx';

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={clsx(
      'block text-sm font-medium text-slate-700',
      className
    )}
    {...props}
  />
));

Label.displayName = 'Label';

export { Label };
